import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
};

const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    saveUserData: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    removeUserData: (state) => {
      state.user = null;
      state.token = null;
    },
  },
});

export const { saveUserData, removeUserData } = userSlice.actions;
export default userSlice.reducer;
